<template>
  <main class="dashboard">
    <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">{{ current_page.name }}</h1>
    </div>
    <div class="text" v-html="current_page.description"></div>



      <template v-if="detail">
        <div class="card">
        <div
            class="card-header d-flex justify-content-between flex-wrap flex-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h4 class="break-anyway"><a :href="detail.link">{{ decodeURI(detail.link) }}</a></h4>

          <button class="btn" @click="detail=null"><b class="h3"><i class="bi bi-x-lg"></i></b>
          </button>
        </div>
        <div class="card-body">
          <ul class="nav nav-tabs" style="flex-wrap: nowrap;">

            <li class="nav-item">
              <button @click="page_type='request'" :class="`${page_type==='request'?'active':''} nav-link ps-2 pe-2`">
                Размещение контента
              </button>
            </li>
            <li class="nav-item">
              <button @click="page_type='content'" :class="`${page_type==='content'?'active':''} nav-link ps-2 pe-2`">
                Контент статьи
              </button>
            </li>
          </ul>
          <template v-if="page_type === 'request'">
            <WikiRequests :objects="detail.request" :wiki_id="detail.id"></WikiRequests>
          </template>
          <template v-if="page_type === 'content'">
            <WikiChange :active_dates="detail.active_dates" :wiki_id="detail.id"></WikiChange>
          </template>
        </div>
        </div>

      </template>
      <div v-else class="card-body links">

        <div class="table-responsive">

          <div class="table-flex-responsive">
            <div class="row header">
              <div class="col-1"> №</div>
              <div class="col-lg-5"> Ссылка на Wikipedia</div>
              <div class="col"></div>
              <div class="col"></div>
            </div>
            <template v-for="(object, index) in objects">
              <div class="row line">

                <div class="col-1 number"><div class="sub-head">№</div>{{ (index + 1) + ((page - 1) * size) }}</div>
                <div class="col sub-head">Ссылка на Wikipedia</div>
                <div :class="'col-lg-5' + (object.link_error?' form-group--error':'')">
                  <template v-if="object.edit">
                      <label class="d-none">Ссылка на Wikipedia</label>
                      <input v-focus class="form-control" type="url" v-model="object.link"
                             v-on:keyup="object.link_error = false">
                    <div class="error" v-if="object.link_error">{{ object.link_error }}</div>
                </template>
                <template v-else>
                  <a :href="object.link" target="_blank" class="break-anyway">{{ decodeURI(object.link) }}</a>
                </template>
                </div>
                <div class="col sub-head"></div>
                <div class="col">
                  <p v-if="object.id">
                    <b>Текстов к размещению:</b> <span>{{ object.request_count }}</span><br>
                    <b>Последнее обновление статьи:</b> <span>{{ object.last_update }}</span>
                  </p>
                </div>
                <div class="col sub-head"></div>
                <div class="col">
                  <template v-if="!object.edit">
                    <a href="" v-on:click.prevent="object.edit = true;"
                       class="no-wrap"><i class="bi bi-pencil"></i>
                      <small>редактировать</small>
                    </a>
                    <br>
                    <button class="btn btn-primary btn-sm mt-2" style="max-width: 150px;" @click="getDetail(object)">
                      Подробнее <i
                        class="bi bi-caret-down"></i></button>
                  </template>
                  <template v-else>
                    <a href="" class="text-success ms-sm-2 no-wrap d-block" v-on:click.prevent="saveNote(object)"><i
                        class="bi bi-check-circle"></i>
                      <small>Сохранить</small>
                    </a>
                    <a href="" class="text-danger ms-sm-2 no-wrap d-block mt-2" v-on:click.prevent="endEdit(object)"><i
                        class="bi bi-x-circle"></i>
                      <small>Отмена</small>
                    </a>
                  </template>

                </div>

              </div>
            </template>
            <div v-if="!objects.length" class="row">
              <div  class="col-12 text-center">
                Не добавлено ни одной записи
              </div>
            </div>
            <div v-if="objects.length < max_length">
              <div>
                <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
              </div>
            </div>
            </div>

        </div>
      </div>
      <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>




  </main>
</template>

<script>
import dataMixin from '../mixins.js';
import {DictionaryApi} from "@/api/dictionary";
import WikiRequests from "@/views/dictionary/wikipedia/WikiRequests.vue";
import WikiChange from "@/views/dictionary/wikipedia/WikiChange.vue";

export default {
  name: 'WikipediaService',
  mixins: [dataMixin],
  components: {WikiRequests, WikiChange},
  data() {
    return {
      name: 'wikipedia',
      detail: null,
      page_type: "request",
      empty: {link: '', date: '', edit: true},
      validate: {
        link: {
          func: (o) => {
            return !o.link || !this.$func.isURL(o.link) || !o.link.includes("wikipedia")
          }, error: 'Неверный формат ссылки'
        },
        // text: {},
      }
    }
  },
  methods: {
    getDetail(object) {
      DictionaryApi.get(this.name, object.id).then(resp => this.detail = resp)
      return object
    },

  }
}
</script>

<style>
textarea {
  min-width: 380px;
}
</style>
